import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { IonicModule } from '@ionic/angular';
import { IonCard } from "@ionic/angular/standalone";
import { PrivacyPoliceComponent } from 'src/app/modals/privacy-police/privacy-police.component';
import { ModalService } from 'src/app/services/utils/modal/modal.service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  imports: [CommonModule, IonicModule],
})
export class CookieBannerComponent implements OnInit {

  showBanner = false;
  public isMobile = false;

  constructor(
    private utils: UtilsService,
    private modals: ModalService
  ) { }

  ngOnInit(){
    const cookies = this.utils.getStorage('aceitaCookies');
    this.showBanner = cookies !== 'true';
  }

  aceitarCookies() {
    this.utils.setStorage('aceitaCookies', 'true');
    this.showBanner = false;
  }

  abrirTermos() {
    this.modals.openModal(
        'modal-politica-privacidade',
        'modal-politica-privacidade',
        PrivacyPoliceComponent,
        true,
        { modal: true }
      );
  }
}
